import _ from 'underscore';

function init({ hubId }) {
  if (document.getElementById('hs-script-loader')) {
    // script already loaded
    return;
  }
  const hsScript = document.createElement('script');
  hsScript.type = 'text/javascript';
  hsScript.async = true;
  hsScript.defer = true;
  hsScript.id = 'hs-script-loader';
  hsScript.src = `//js.hs-scripts.com/${hubId}.js`;
  
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(hsScript, firstScript);
};

function identify({ email }) {
  window._hsq = window._hsq || [];
  const isAlreadyQueued = _.some(window._hsq, function(item) {
    return item[0] === 'identify';
  });
  if (isAlreadyQueued) {
    return;
  }
  window._hsq.push(['identify', {
    email,
  }]);
  // Flush the identification to HubSpot
  window._hsq.push(['trackPageView']);
}

export const HubSpot = { init, identify };
